<template>
  <div class="users-style">
    <h4 class="atlhr-dashboard-title mt-10">
      {{ run_approved ? 'Approved' : 'Draft' }} Penalty Run for {{ month_label }} <b-icon icon="check-circle-fill" variant="success" v-if="run_approved"></b-icon>
      <span>
        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a>
        / <a v-bind:href="$api_url + '/leave-attendance/penalty'">Penalty Runs</a>
        / Penalty Details
      </span>
    </h4>

    <div class="ibox p-4 mt-3">
      <div class="row mb-2 mt-2">
        <div class="col-md-12">
          <div class="d-flex justify-content-end align-items-center flex-wrap">

            <template v-if="run_approved === true">
              <b-button size="sm" class="mr-2 mb-2" :disabled="loading" @click="confirmRevert">
                <b-icon icon="skip-backward" class="mr-1"></b-icon>
                Revert to Draft
              </b-button>
            </template>

            <template v-if="run_approved === false">
              <b-button :disabled="loading" class="mb-2 mr-2 btn-approved" href="javascript:void(0);"
                @click="confirmApprove()">
                <b-icon icon="check-circle-fill" class="mr-2" scale="1"></b-icon>Approve Run
              </b-button>

              <button class="btn btn-delete px-3 py-2 mb-2 mr-2 font-semi-bold" :disabled="loading" @click="confirmDeleteRun">
                <b-icon icon="trash" class="mr-1"></b-icon>
                Delete Run
              </button>

              <b-button size="sm" variant="primary" class="mr-2 mb-2" @click="ignorePenalty(null, 1)">
                Grace All Records To Selected Employees
              </b-button>
            </template>

            <a class="btn btn-sm btn-primary mb-2 text-light" :href="$api_url + '/leave-attendance/penalty'">
              <i class="fa fa-arrow-left mr-1" aria-hidden="true"></i>
              Back to List
            </a>

          </div>
        </div>
      </div>

      <div v-if="error_msg != ''" class="alert alert-danger" role="alert">
        {{ error_msg }}
      </div>

      <div class="text-center" v-if="page_loader">
        <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
      </div>
      <div v-else>
        <common-list :pageurl="$api_url" :checkbox="run_approved ? 0 : 1" :is_action="1" :appended_column="appended_column"
          :key="list_key" :company_options="company_options" :employees="list_rows" :default_column="default_column"
          :primary_key="'penalty_id'" :all_employee="'no'" v-on:childToParent="listReturn"></common-list>
      </div>

    </div>
    <b-modal id="penalty-details-modal" size="xxl" title="Penalty Details" hide-footer>
      <roster-penalty-details @reloadData="fetchPenalties" :can_edit="true && !run_approved"
        :row="selectedPenaltyRow"></roster-penalty-details>
    </b-modal>
    <b-modal id="penalty-policy-modal" size="lg" centered hide-footer>
      <template #modal-title>
        <h5 class="mb-0">Penalty Policy — {{ selectedPolicyEmployee }}</h5>
      </template>

      <div v-if="selectedPolicy" class="p-3">

        <div class="mb-3 pb-2 border-bottom">
          <strong>Policy Name:</strong> {{ selectedPolicy.name || '-' }}
        </div>

        <div v-for="(rule, type) in selectedPolicy.policy_details" :key="type" class="mb-3 p-3 rounded" style="background: #f8f9fa;">

          <h6 class="font-weight-bold text-primary border-bottom pb-2 mb-3">{{ getPenaltyTypeText(type) }}</h6>

          <div class="row">
            <div class="col-md-6 mb-2">
              <strong>Status:</strong>
              <span :class="rule.status == 1 ? 'text-success' : 'text-danger'">
                {{ rule.status == 1 ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>

          <template v-if="type != 'incomplete'">
            <div class="row mb-2">
              <div class="col-md-6">
                <strong>Rule Type:</strong> {{ rule.factor == 1 ? 'Factor Rule' : 'Fixed Rule' }}
              </div>
            </div>

            <div v-if="parsePolicyJson(rule.conversion_rules).length > 0" class="mb-3">
              <strong>Conversion Rules:</strong>
              <table class="table table-sm table-bordered mt-1 mb-0">
                <thead class="table-head">
                  <tr>
                    <th>{{ getPenaltyDaysLabel(type) }}</th>
                    <th>Deduction Days</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(crule, idx) in parsePolicyJson(rule.conversion_rules)" :key="idx">
                    <td>{{ crule.days }}</td>
                    <td>{{ crule.deduct }} day(s)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="parsePolicyJson(rule.leave_deduction_layers).length > 0" class="mb-2">
              <strong>Leave Deduction Layers:</strong> {{ leaveLayerNames(rule.leave_deduction_layers) }}
            </div>

            <div v-if="rule.salary_deduction_enabled == 1" class="row">
              <div class="col-md-6 mb-2">
                <strong>Salary Deduction:</strong> {{ rule.salary_percentage }}%
              </div>
              <div class="col-md-6 mb-2">
                <strong>Salary Depends On:</strong> {{ rule.salary_depends_on == 1 ? 'Gross' : 'Basic' }}
              </div>
            </div>
          </template>

          <template v-else>
            <div class="row">
              <div class="col-md-6 mb-2">
                <strong>Deduction Type:</strong> {{ rule.deduct_from == 1 ? 'Salary' : 'Leave' }}
              </div>
              <div class="col-md-6 mb-2">
                <strong>Incomplete Hours Limit:</strong> {{ rule.frequency }} Hr(s)
              </div>
              <div class="col-md-6 mb-2">
                <strong>Grace Limit:</strong> {{ rule.grace }} Hr(s)
              </div>
              <div class="col-md-6 mb-2">
                <strong>Deduction Days:</strong> {{ rule.leave_deduct }} Day(s)
              </div>
            </div>
          </template>

        </div>

        <div v-if="!selectedPolicy.policy_details || Object.keys(selectedPolicy.policy_details).length === 0"
          class="text-muted text-center py-3">No penalty rules configured.</div>

      </div>
      <div v-else class="text-muted text-center py-3">No policy data available.</div>
    </b-modal>

    <b-modal id="penalty-approve-password-modal" title="Confirm Password" centered hide-footer>
      <p class="mb-2">Enter your password to approve this penalty run.</p>
      <b-form-input type="password" v-model="approve_password" placeholder="Password"
        autocomplete="current-password"></b-form-input>
      <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
      <b-button @click="submitApprove" class="w-100 my-2">Approve</b-button>
      <b-button @click="$bvModal.hide('penalty-approve-password-modal')" class="w-100">Cancel</b-button>
    </b-modal>

    <b-modal id="penalty-revert-password-modal" title="Confirm Password" centered hide-footer>
      <p class="mb-2">Enter your password to revert this penalty run to draft.</p>
      <b-form-input type="password" v-model="approve_password" placeholder="Password"
        autocomplete="current-password"></b-form-input>
      <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
      <b-button @click="submitRevert" class="w-100 my-2">Revert To Draft</b-button>
      <b-button @click="$bvModal.hide('penalty-revert-password-modal')" class="w-100">Cancel</b-button>
    </b-modal>

    <b-modal id="penalty-run-delete-password-modal" title="Confirm Password" centered hide-footer>
      <p class="mb-2">Enter your password to delete this penalty run.</p>
      <b-form-input type="password" v-model="approve_password" placeholder="Password"
        autocomplete="current-password"></b-form-input>
      <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
      <b-button class="w-100 my-2" variant="primary" :disabled="loading" @click="submitDeleteRun">Delete</b-button>
      <b-button class="w-100" @click="$bvModal.hide('penalty-run-delete-password-modal')">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  props: ['run_id'],
  data() {
    return {
      leavetypes: [],
      selectedPenaltyRow: null,
      selectedDetailIds: [],
      selectAllDetails: false,
      selectedPenaltyId: null,
      selectedPenaltyIds: [],
      months_list: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      page_loader: true,
      error_msg: '',
      penalties: [],
      year: '',
      month: '',
      month_label: '',
      run_approved: null,
      loading: false,
      approve_password: '',
      approve_error: '',
      selectedPolicy: null,
      selectedPolicyEmployee: '',
      list_key: 0,
      list_rows: [],
      company_options: [],
      employee_map: {},
      default_column: ['name', 'employee_code'],
      appended_column: [
        { value: 'attendance_from', text: 'From', type: 'text' },
        { value: 'attendance_to', text: 'To', type: 'text' },
        { value: 'amount', text: 'Total Deduction Days', type: 'text' },
        { value: 'leave_deduct_text', text: 'Leave Deduct', type: 'text' },
        { value: 'salary_deduct', text: 'Salary Deduct (Days)', type: 'text' },
        { value: 'graced_count', text: 'Graced (Days)', type: 'text' },
      ],
    }
  },
  mounted() {
    this.fetchPenalties();
    this.getLeaveTypes();
  },
  methods: {
    viewPenalty(data) {
      this.penaltyDetails = [];
      this.selectedDetailIds = [];
      this.selectAllDetails = false;
      this.employee = {
        name: "",
        employee_code: "",
        pic: ""
      };
      this.selectedPenaltyId = data.id;
      this.selectedPenaltyRow = data;

      let formData = new FormData();
      formData.append("employee_id", data.employee_id);

      this.loading = true;

      axios.post(this.$api_url + "/employee/setemployee", formData).then(() => {
        this.$bvModal.show("penalty-details-modal");
        this.loading = false;
      });
    },
    penaltyStatusLabel(row) {
      if (row.leave_settled == 1) return 'Settled';
      if (row.status == 1) return 'Approved';
      if (row.status == 2) return 'Grace';
      return 'Draft';
    },
    buildListRows() {
      this.list_rows = this.penalties.map(row => {
        const employee = this.employee_map[row.employee_id] || { pic: '', company_id: '' };
        const actions = [
          { label: 'Preview', value: 1 },
          { label: 'View Policy', value: 3 },
        ];
        if (!this.run_approved) {
          actions.push({ label: 'Grace All Record', value: 2 });
        }

        return {
          ...employee,
          penalty_id: row.id,
          employee_id: row.employee_id,
          name: row.name,
          policy: row.policy,
          employee_code: row.employee_code,
          attendance_from: row.attendance_from,
          attendance_to: row.attendance_to,
          amount: row.amount,
          leave_deduct_text: (row.leave_breakdown || []).map(v => v.leave_type + ': ' + v.value).join(', '),
          salary_deduct: row.salary_deduct,
          graced_count: row.graced_count,
          status: this.penaltyStatusLabel(row),
          actions: actions,
        };
      });
      this.list_key++;
    },
    showPenaltyPolicy(row) {
      this.selectedPolicyEmployee = row.name + ' (' + row.employee_code + ')';
      try {
        this.selectedPolicy = typeof row.policy === 'string' ? JSON.parse(row.policy) : row.policy;
      } catch (e) {
        this.selectedPolicy = null;
      }
      this.$bvModal.show('penalty-policy-modal');
    },

    getPenaltyTypeText(type) {
      const map = { absent: 'Absent', late: 'Late Clock In', early: 'Early Clock Out', incomplete: 'Incomplete Hours' };
      return map[type] || type;
    },

    getPenaltyDaysLabel(type) {
      const map = { absent: 'Absent Days', late: 'Late Clock In (Days)', early: 'Early Out (Days)', incomplete: 'Incomplete Days' };
      return map[type] || 'Days';
    },

    getLeaveTypes() {
      axios.get(this.$api_url + '/leave-attendance/leave/type/list').then(response => {
        this.leavetypes = response.data || [];
      }).catch(error => {
        this.serverError(error);
      });
    },
    leaveLayerNames(val) {
      return this.parsePolicyJson(val).map(id => {
        const type = this.leavetypes.find(t => t.value == id);
        return type ? type.text : id;
      }).join(' → ');
    },
    parsePolicyJson(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      try { return JSON.parse(val); } catch (e) { return []; }
    },
    listReturn(data) {
      if (data.selected && data.selected.length > 0) {
          this.selectedPenaltyIds = data.selected.map(sel => {
              const row = this.list_rows.find(r => r.penalty_id == sel);
              return row ? row.penalty_id : sel;
          });
          return;
      }

      this.selectedPenaltyIds = [];
      const row = this.penalties.find(item => item.id == data.penalty_id);
      if (!row) return;

      if (data.action_id == 1 || data.action_id == 0) {
          this.viewPenalty(row);
      } else if (data.action_id == 2 && !this.run_approved) {
          this.ignorePenalty(row);
      } else if (data.action_id == 3) {
          this.showPenaltyPolicy(row);
      }
  },
    fetchEmployees() {
      return axios.get(this.$api_url + '/employee/list').then((response) => {
        const map = {};
        (response.data.employee_data || []).forEach(employee => { map[employee.employee_id] = employee; });
        this.employee_map = map;
        this.company_options = response.data.options || [];
      }).catch(() => {
        this.company_options = [{ label: 'name' }, { label: 'employee_code' }];
      });
    },
    confirmDeleteRun() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this penalty run?', {
        title: 'Confirm Deletion',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('penalty-run-delete-password-modal');
      });
    },
    submitDeleteRun() {
      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/penalty-runs/delete/' + this.run_id, formData)
        .then(() => {
          this.$bvModal.hide('penalty-run-delete-password-modal');
          window.location.href = this.$api_url + '/leave-attendance/penalty';
        })
        .catch((error) => {
          this.approve_error = (error.response && error.response.data && error.response.data.message)
            || 'Failed to delete penalty run.';
          this.loading = false;
        });
    },
    fetchPenalties() {
      this.page_loader = true;

      let formData = new FormData();
      formData.append('run_id', this.run_id);

      const runRequest = axios.post(this.$api_url + '/leave-attendance/penalty-runs/' + this.run_id)
        .then((response) => {
          this.month_label = response.data.month_label;
          this.year = response.data.year;
          this.run_approved = (response.data.status == 1);
        })
        .catch(() => {
        });

      const employeeRequest = this.company_options.length > 0 ? Promise.resolve() : this.fetchEmployees();

      const penaltyRequest = axios.post(this.$api_url + '/leave-attendance/penalty/preview', formData)
        .then((response) => {
          this.penalties = response.data || [];

          if (this.penalties.length > 0 && this.penalties[0].attendance_from) {
            const parts = String(this.penalties[0].attendance_from).split('-');
            this.year = parts[0] || '';
            this.month = parts[1] || '';
          }
        });

      Promise.all([runRequest, employeeRequest, penaltyRequest])
        .then(() => {
          this.selectedPenaltyIds = [];
          this.buildListRows();
          this.page_loader = false;
        })
        .catch(() => {
          this.error_msg = 'Failed to load penalty data.';
          this.page_loader = false;
        });
    },

    confirmApprove() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to approve?', {
        title: 'Confirm Approval',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) {
          return;
        }

        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('penalty-approve-password-modal');
      });
    },

    confirmRevert() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to revert this run to draft?', {
        title: 'Confirm Revert',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) {
          return;
        }

        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('penalty-revert-password-modal');
      });
    },

    graceSelected() {
      if (!this.selectedDetailIds || this.selectedDetailIds.length == 0) {
        this.$bvToast.toast("Select at least one record.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return;
      }

      for (let i = 0; i < this.penaltyDetails.length; i++) {
        if (this.selectedDetailIds.indexOf(this.penaltyDetails[i].id) !== -1) {
          this.$set(this.penaltyDetails[i], "grace", 1);
        }
      }
    },

    applyPenalty(status) {
      this.$bvModal.msgBoxConfirm("Do yoy want to ", {
        title: "Are you sure?",
        size: "sm",
        buttonSize: "sm",
        okVariant: "primary",
        okTitle: "Yes",
        cancelTitle: "Cancel",
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (!value) {
          return;
        }

        if (this.penaltyDetails.length == 0) {
          return;
        }

        try {
          const formData = new FormData();

          const dates = this.penaltyDetails.map(item => {
            return moment(item.date, "YYYY-MM-DD");
          });

          const from = moment.min(dates).format("YYYY-MM-DD");
          const to = moment.max(dates).format("YYYY-MM-DD");

          const penaltyGraceMap = this.penaltyDetails.reduce((acc, item) => {
            acc[item.id] = Number(item.grace);
            return acc;
          }, {});

          const employee_id = this.penaltyDetails[0].employee_id;

          formData.append("from", from);
          formData.append("to", to);
          formData.append("status", status);
          formData.append("employee_id", employee_id);
          formData.append("penalty_id", this.selectedPenaltyId);
          formData.append("penalty_grace", JSON.stringify(penaltyGraceMap));

          this.loading = true;

          axios.post(this.$api_url + "/leave-attendance/penalty/update", formData)
            .then(response => {
              this.$bvToast.toast(response.data.message, {
                solid: true,
                title: "Success",
                variant: "success"
              });

              this.$bvModal.hide("penalty-details-modal");

              const reloadFormData = new FormData();
              reloadFormData.append("year", this.year);
              reloadFormData.append("month", this.month);

              axios.post(this.$api_url + "/leave-attendance/penalty/preview", reloadFormData)
                .then(previewResponse => {
                  this.penalties = previewResponse.data || [];
                  this.loading = false;
                })
                .catch(() => {
                  this.loading = false;
                });
            });
        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },

    submitApprove(bvEvent) {
      if (bvEvent) {
        bvEvent.preventDefault();
      }

      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/penalty-runs/' + this.run_id + '/approve', formData)
        .then(function (response) {
          this.$bvToast.toast(response.data.message || 'Penalty run approved.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });

          this.run_approved = true;
          this.approve_password = '';
          this.$bvModal.hide('penalty-approve-password-modal');
          this.fetchPenalties();
        }.bind(this))
        .catch(function (error) {
          if (error.response && error.response.data && error.response.data.message) {
            this.approve_error = error.response.data.message;
          }
          else {
            this.approve_error = 'Failed to approve penalty run.';
          }
        }.bind(this))
        .finally(function () {
          this.loading = false;
        }.bind(this));
    },
    ignorePenalty(data = null, flag) {
        let ids = [];
        let msg = '';

        if (data) {
            ids = [data.id];
            msg = 'Grace penalty for ' + data.name + '?';
        } else if (flag == 1) {
            if (!this.selectedPenaltyIds || this.selectedPenaltyIds.length == 0) {
                this.$bvToast.toast("Select at least one record.", {
                    title: "Warning", variant: "warning", solid: true
                });
                return;
            }
            ids = this.selectedPenaltyIds;
            msg = 'Grace selected penalties?';
        }

        this.$bvModal.msgBoxConfirm(msg, {
            title: "Please Confirm",
            size: "sm",
            okVariant: "primary",
            okTitle: "Grace",
            cancelTitle: "Cancel",
            centered: true,
            bodyClass: "text-center",
            footerClass: "p-2 border-0 d-flex justify-content-center",
        }).then(value => {
            if (!value) return;

            const formData = new FormData();
            formData.append("status", 2);
            formData.append("all", 0);
            formData.append("penalty_ids", JSON.stringify(ids));

            this.loading = true;

            axios.post(this.$api_url + "/leave-attendance/penalty/ignore", formData)
                .then(response => {
                    this.$bvToast.toast(response.data.message, {
                        solid: true, title: "Success", variant: "success"
                    });
                    this.selectedPenaltyIds = [];
                    this.loading = false;
                    this.fetchPenalties();
                })
                .catch(e => {
                    this.serverError(e);
                    this.loading = false;
                });
        });
    },

    submitRevert(bvEvent) {
      if (bvEvent) {
        bvEvent.preventDefault();
      }

      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/penalty-runs/' + this.run_id + '/revert', formData)
        .then(function (response) {
          this.$bvToast.toast(response.data.message || 'Penalty run reverted to draft.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });

          this.run_approved = false;
          this.approve_password = '';
          this.$bvModal.hide('penalty-revert-password-modal');
          this.fetchPenalties();
        }.bind(this))
        .catch(function (error) {
          if (error.response && error.response.data && error.response.data.message) {
            this.approve_error = error.response.data.message;
          }
          else {
            this.approve_error = 'Failed to revert penalty run.';
          }
        }.bind(this))
        .finally(function () {
          this.loading = false;
        }.bind(this));
    },
  }
}
</script>
